import { ThunkDispatch } from "core-integration/src/store";
import { logout as logoutAction } from "core-integration/src/store/player/thunks";
import { getD3AuthDomain } from "../providers/D3AuthProvider";

/**
 * Handle user logout with D3/OIDC following Peter's flow:
 *
 * Flow:
 * 1. Client -> Identity Service: POST /auth/logout with JWT + redirect_uri
 * 2. Identity Service: End session
 * 3. Identity Service -> Client: 302 redirect to static resource logout page
 * 4. Client -> Static Resource: Redirect to logout page
 * 5. Static Resource -> Identity Provider: Sign out user
 * 6. Static Resource -> Client: Redirect to redirect_uri (our homepage)
 *
 * Example logout URL from Peter:
 * https://account.spl-dev.deltatre.digital/adb2c-resources/main/logout.html?post_logout_redirect_uri=https://react-fe.spl-dev.deltatre.digital/en/
 */
export const handleLogout = async (
  dispatch: ThunkDispatch,
  isWebView = false,
) => {
  try {
    // Clear Firebase session flags
    sessionStorage.removeItem("firebase_authenticated");
    localStorage.removeItem("firebase_loginError");

    // Call backend logout to clear Django session
    await dispatch(logoutAction());

    // If webview, just go to homepage (no D3 logout needed)
    if (isWebView) {
      window.location.href = "/?webview=1";
      return;
    }

    // For web: Redirect to D3 logout static page
    // This will handle the full D3 logout flow and redirect back to us
    const postLogoutRedirectUri = window.location.origin + "/";

    // Get D3 auth domain from the configured authority
    // e.g., https://account.spl-dev.deltatre.digital/identity/v1/main
    // -> https://account.spl-dev.deltatre.digital
    const authDomain = getD3AuthDomain();
    const baseDomain = authDomain.replace(/\/identity\/v1\/main$/, "");

    // D3 logout URL: base domain + static logout page + redirect back to our homepage
    // Example: https://account.spl-dev.deltatre.digital/adb2c-resources/main/logout.html?post_logout_redirect_uri=https://react-fe.spl-dev.deltatre.digital/en/
    const d3LogoutUrl = `${baseDomain}/adb2c-resources/main/logout.html?post_logout_redirect_uri=${encodeURIComponent(
      postLogoutRedirectUri,
    )}`;

    window.location.href = d3LogoutUrl;
  } catch (err) {
    // Redirect anyway to ensure user can get to login page
    window.location.href = "/";
  }
};
